import { default as styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

export const HiddenFileInput = styled.input`
  visibility: hidden;
  position: absolute;
  top: 0;
`;
